export class CategoryConstant {
    static Uncategorized() {
        return "89d35d91-09e8-41a7-8cd4-78a05cc3cd0f";
    }
}
